// @ts-nocheck
import { Component, Input, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbCarousel, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin.service';
import { PlansService } from 'src/app/services/plans.service';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';

import { HeaderOneComponent } from '../../shared/header/header-one/header-one.component';
@Component({
  standalone: true,
  selector: 'app-plans-price',
  templateUrl: './plans-price.component.html',
  styleUrl: './plans-price.component.scss',
  imports: [CommonModule, MatTabsModule, HeaderOneComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PlansPriceComponent {
  [key: string]: any;
  constructor(
    private router: Router,
    private adminService: AdminService,
    private fb: FormBuilder,
    config: NgbCarouselConfig,
    private dialog: MatDialog,
    private plansService: PlansService
  ) {}

  ngOnInit() {}

  getPlans() {}

  logSubPlans(plan: any) {}

  goTo(plan: any) {}
}
